// extracted by mini-css-extract-plugin
export default {"loaderContainer":"OrganizationDetail_loaderContainer__A5FNb","backButton":"OrganizationDetail_backButton__Bm3ba"};